export function handleInternalSpaNavigation(
  href: string,
  event: Event,
): boolean {
  const allowedPrefixes = [
    "/legislacao/",
    "/doutrina/",
    "/jurisprudencia/",
    "/modelos/",
  ];

  const isInternal = allowedPrefixes.some((prefix) => href.startsWith(prefix));

  if (!isInternal) return false;

  event.preventDefault();
  window.history.pushState({}, "", href);
  window.dispatchEvent(new PopStateEvent("popstate"));

  return true;
}
